<template>
  <div>
    <el-dialog
      title=""
      :visible.sync="$store.getters.showProductsDialog"
      width="80%"
      :before-close="handleClose"
    >
      <el-header>
        <el-row>
          <el-col :span="18">
            <h4>Выбор товаров</h4>
          </el-col>
          
          <el-col :span="6">
            <el-checkbox              
              v-model="onlyChecked"
              @change="changeOnlyChecked"
            >
              Только выбранные
            </el-checkbox>
          </el-col>
        </el-row>
      </el-header>
      <el-main height="80%">
        <el-form aria-label="Поиск" label-width="150px" label-position="left">
          <el-row>
            <el-col :lg="12" :xl="8">
              <el-form-item label="Поиск по названию">
                <el-col :span="14">
                  <el-input v-model="query.q" @input="changeRequest"></el-input>
                </el-col>
              </el-form-item>
            </el-col>
            <el-col :lg="12" :xl="8">
              <el-form-item label="Поиск по категории">
                <el-row>
                    <el-button size="small" type="primary" @click="toggleDialog()">Выбрать</el-button>
                  </el-row>
                  <el-row v-if="selectedSections.length">
                    <el-col>
                      <el-tag 
                        v-for="(it, index) in selectedSections"
                        :key="it.id"
                        checked
                        closable
                        @close="handleDeleteCat(index)"
                      >{{it.title}}</el-tag>
                    </el-col>
                  </el-row>
              </el-form-item>
            </el-col>
            <el-col :lg="12" :xl="8">
              <el-form-item label="Сортировка">
                <el-select
                  v-model="query.sort"
                  clearable
                  style="width: 300px"
                  placeholder="Сортировка"
                  no-data-text="Нет данных"
                  @change="(e) => sortProduct(e)"
                >
                  <el-option
                    v-for="(item, index) in sortConfig"
                    :key="index"
                    :value="item.field"
                    :label="item.title"
                  />
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
        <el-table :data="products" style="width: 100%" empty-text="Нет данных">
          <el-table-column width="50">
            <template slot-scope="scope">
              <el-checkbox
                :value="includeInChecked(products[scope.$index])"
                @change="changeChecked(products[scope.$index])"
              ></el-checkbox>
            </template>
          </el-table-column>
          <el-table-column type="expand">
            <template slot-scope="props">
              <p>
                Разделы каталога:
                <template v-if="props.row.section">
                  <span>{{ props.row.section.path }}</span>
                </template>
              </p>
              <p>Артикул: {{ props.row.article }}</p>
            </template>
          </el-table-column>
          <el-table-column prop="id" label="Id" width="50"> </el-table-column>
          <el-table-column prop="title" label="Название"> </el-table-column>

          <el-table-column prop="sort" label="Сортировка" width="150">
          </el-table-column>
          <el-table-column label="Активность" width="150">
            <template slot-scope="scope">
              <p v-if="!products[scope.$index].activity">Нет</p>
              <p v-if="products[scope.$index].activity">Да</p>
            </template>
          </el-table-column>
        </el-table>
      </el-main>
      <el-footer height="5%">
        <el-pagination
          background
          layout="prev, pager, next"
          :total="paginator.total"
          :current-page.sync="paginator.current_page"
          @current-change="getPage(paginator.current_page)"
          :hide-on-single-page="true"
          :page-size="paginator.per_page"
          :page-count="paginator.last_page"
        >
        </el-pagination>
      </el-footer>
      <span slot="footer" class="dialog-footer">
        <el-button @click="$store.commit('showProductsDialog', false)"
          >Отмена</el-button
        >
        <el-button type="primary" @click="saveCheckedProducts"
          >Сохранить</el-button
        >
      </span>
    </el-dialog>
      <CatalogSectionDialog
        v-if="$store.getters.showCatalogSectionDialog"
        :items-payload="selectedSections"
        @saveItems="onSaveItems"
      />
  </div>
</template>

<script>
import axios from "axios";
import sortConfig from "../../composable/config/products-sort.config";
import { SETPRELOADER_STATE } from "../../store/mutation-types.js";
import CatalogSectionDialog from '@/components/CatalogSectionDialog'

export default {
  components: {
    CatalogSectionDialog,
  },
  props: ["selectedProducts"],
  data: function () {
    return {
      sortConfig,
      products: [],
      paginator: [],
      query: {
        q: "",
        sort: sortConfig[0].field,
      },
      ids: [],
      sections: [],
      onlyChecked: false,
      timeoutSearch: null,
      selectedSections: [],
    };
  },
  computed: {
    activeSort() {
      const result = this.sortConfig.find((e) => e.field === this.query.sort);
      return result ? result.options : undefined;
    },
    queryComputed() {
      const sort = this.activeSort;
      const q = this.query.q;
      const sectionsId = this.selectedSections.length ? this.selectedSections[0].id : 0;
      const result = {};
      let isChange = false;

      if (sort) {
        isChange = true;
        result["sort"] = sort;
      }

      if (q) {
        isChange = true;
        result["q"] = q;
      }

      if (sectionsId) {
        isChange = true;
        result["section_id"] = sectionsId;
      }

      return isChange ? result : undefined;
    },
  },
  mounted() {
    this.getProducts();
  },
  methods: {
    initIbs() {
      this.ids = this.selectedProducts;
    },
    changeRequest() {
      if (this.timeoutSearch) {
        clearTimeout(this.timeoutSearch);
      }

      if (this.onlyChecked) {
        this.timeoutSearch = setTimeout(() => {
          this.getSelectedProducts();
          this.resetPaginator();
        }, 500);
      } else {
        this.getProducts();
      }
    },
    changeOnlyChecked() {
      if (this.onlyChecked) {
        this.getSelectedProducts();
        this.resetPaginator();
      } else {
        this.getProducts();
      }
    },
    getSelectedProducts() {
      this.products = this.ids;
    },
    saveCheckedProducts() {
      this.$emit("updateParent", [...this.ids]);
      this.handleClose();
    },
    includeInChecked(product) {
      return !!this.ids.find((e) => e.id === product.id);
    },
    changeChecked(product) {
      const findIndex = this.ids.findIndex((e) => e.id === product.id);

      if (findIndex >= 0) {
        this.ids.splice(findIndex, 1);
      } else {
        this.ids.push(product);
      }

      this.$emit("select-product", this.ids.length);
    },
    getProducts: function (query) {
      const qs = require("qs");
      let q;

      if (query) {
        q = query;
      } else {
        q = this.queryComputed ? `?${qs.stringify(this.queryComputed)}` : "";
      }

      this.$store.commit(SETPRELOADER_STATE, true);

      axios
        .get("product" + q)
        .then((response) => {
          this.products = response.data.data;
          this.paginator = response.data.meta;

          this.initIbs();
        })
        .catch((errors) => {
          if (errors.response.status === 401) {
            this.$router.push("/login");
          }
        }).finally(() => {
          this.$store.commit(SETPRELOADER_STATE, false);
        });
    },
    getPage: function (pageNum) {
      const qs = require("qs");
      const qProps = this.queryComputed
        ? `&${qs.stringify(this.queryComputed)}`
        : undefined;
      const q = `?page=${pageNum}${qProps}`;
      this.getProducts(q);
    },
    handleClose() {
      this.$store.commit("showProductsDialog", false);
      this.ids = [];
    },
    resetPaginator() {
      this.paginator = {};
    },
    sortProduct(value, products) {
      this.products = products || this.products;

      this.query.sort = value;
      const sortItems = this.$store.getters.sortItems;

      const current = sortItems.find((el) =>
        el.names.includes(this.query.sort)
      );

      if (current) {
        const key = this.query.sort.split(".")[0];
        const changedKey = key === "deleted_at" ? "activity" : key;

        current.sort(this.products, changedKey);
      }
    },
    toggleDialog() {
      this.$store.commit('showCatalogSectionDialog', !this.$store.getters.showCatalogSectionDialog);
    },
    onSaveItems(items) {
      this.selectedSections = items;
      this.getProducts();
    },
    handleDeleteCat(index){
      this.selectedSections.splice(index, 1)
      this.getProducts();
    },
  },
};
</script>

<style scoped>
</style>